import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { BackToTop } from "./components/back-to-top/back-to-top";
import { ConfirmDialog } from "./components/confirm-dialog/confirm-dialog";
import { SidePanel } from "./components/side-panel/side-panel";
import { Toastr } from "./components/toastr/toastr";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, Toastr, SidePanel, ConfirmDialog, BackToTop],
  template: `
    <router-outlet></router-outlet>
    <app-toastr />
    <app-side-panel />
    <app-confirm-dialog />
    <app-back-to-top />
  `
})
export class App {}
